
ko.extenders.urlize = function (target, opt) {

    var result = ko.computed({
        read: target,
        write: function (value) {
            var url = value;
            var prefix = 'https://';
            if (url) {
                if (url.substr(0, prefix.length) !== prefix && url.substr(0, 'http://'.length) !== 'http://') {
                    url = prefix + url;
                }
            }
            target(url);
            target.valueHasMutated();
        }
    });

    return result;
};